import React from 'react';
import {withDynamicComponents} from 'higher-order-components';
import FullWidth from '../../containers/full-width';
import PhotoInfo from '../../containers/photo-info';

const FullWidthBlock = props => <FullWidth {...props} />;
FullWidthBlock.displayName = 'FullWidth';

export default withDynamicComponents({
  componentWhitelist: [
    PhotoInfo,
  ],
  mapInputToOutput: [
    ['photoInfo', 'photoInfo'],
  ],
})(FullWidthBlock);



// WEBPACK FOOTER //
// ./src/blocks/full-width/index.jsx